import React, { useEffect } from 'react';

const HUBSPOT_PORTAL_ID = '47654427';
const HUBSPOT_FORM_ID = '86f88355-cd43-4e4f-880b-86b8e613a673';

function FormularioContactoFollaje() {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = '//js.hsforms.net/forms/embed/v2.js';
        script.type = 'text/javascript';
        script.charset = 'utf-8';
        script.onload = () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId: HUBSPOT_PORTAL_ID,
                    formId: HUBSPOT_FORM_ID,
                    target: '#hubspotFormFollaje',
                });
            }
        };
        document.body.appendChild(script);
    }, []);

    return (
        <section id="contacto" className="bg-light">
            <div className="container">
                <div className="title-style2 text-center mb-2-2">
                    <h2 className="h1">¡Contáctanos para cotizar tu follaje artificial!</h2>
                </div>
                <div className="row">
                    <div
                        className="col-lg-8 mb-5 mb-lg-0 mb-md-5 mx-auto wow fadeIn"
                        data-wow-delay="400ms"
                    >
                        <div className="contact-form p-4 p-md-5 bg-white rounded">
                            <form className="quform">
                                <div id="hubspotFormFollaje"></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FormularioContactoFollaje;